import classNames from 'classnames';
import { Button } from 'yoso';
import { BaseCard } from '~/components/Card';
import {
  LeaderboardGroup,
  useChallengeLeaderboard,
} from '~/components/Challenge/Leaderboard/ChallengeLeaderboard.hooks';
import { T } from '~/components/I18n';
import { Chevron } from '~/components/Icon/v2/Chevron';
import { useMember } from '~/components/Member/Member.hooks';
import { Link } from '~/components/Route/Link';
import styles from './ChallengeRewardCta.module.scss';

export type ChallengeRewardCtaProps = {
  className?: string;
  group: LeaderboardGroup;
  eventId?: number;
};
const DOSI_URL = import.meta.env.VITE_DOSI_URL;

export const ChallengeRewardCta = ({ className, group, eventId }: ChallengeRewardCtaProps) => {
  const {
    data: { isLoggedIn },
  } = useMember();
  const {
    data: { weekStatus },
  } = useChallengeLeaderboard({ group, week: eventId }, { enabled: !!eventId });
  return (
    <div className={classNames(styles.root, className)}>
      {isLoggedIn && (
        <p className={styles.description}>
          <T name="citizen_challenge_ranking_participation_history" />{' '}
          <Link
            to="/challenge/event"
            className={styles.link}
            data-event="click"
            data-event-target="round_myhistory_btn_in_leaderboard">
            <T name="citizen_challenge_ranking_participation_history_btn" />
            <Chevron className={styles.chevron} direction="right" />
          </Link>
        </p>
      )}
      {weekStatus === 'IN_PROGRESS' && (
        <BaseCard color="muted" className={styles.card} size="large">
          <div className={styles.cardBody}>
            <small className={styles.small}>
              <T name="citizen_challenge_ranking_participation_guide1" />
            </small>
            <strong className={styles.strong}>
              <T name="citizen_challenge_ranking_participation_guide2" />
            </strong>
          </div>
          <Button
            as="a"
            href={`${DOSI_URL}/market`}
            className={styles.button}
            size="small"
            color="secondary"
            data-event="click"
            data-event-target="round_gotomarket_btn_in_leaderboard">
            <T name="citizen_challenge_ranking_participation_guide_btn" />
          </Button>
        </BaseCard>
      )}
    </div>
  );
};
